import React, { useState } from "react";

const CtaArea = () => {
  const [isLoading, setLoading] = useState(null);
  return (
    <>
      <section className="tp-appoint-cta-area yellow-dark-bg pt-80 pb-65">
        <div className="container">
          <div className="row align-items-center custom-mar-20">
            <div className="col-xl-2 col-lg-12 custom-pad-20">
              <div className="tp-appoint wow fadeInUp" data-wow-delay=".1s">
                <h4 className="tp-appoint-title">
                  Votre <br /> Demande{" "}
                </h4>
              </div>
            </div>
            <div className="col-xl-8 col-lg-9 custom-pad-20">
              <div className="row align-items-center custom-mar-20">
                <div className="col-lg-4 custom-pad-20">
                  <div className="tp-appoint wow fadeInUp" data-wow-delay=".3s">
                    <input type="text" placeholder="Nom complet" />
                  </div>
                </div>
                <div className="col-lg-4 custom-pad-20">
                  <div className="tp-appoint wow fadeInUp" data-wow-delay=".5s">
                    <input type="text" placeholder="Numéro de téléphone" />
                  </div>
                </div>
                <div className="col-lg-4 custom-pad-20">
                  <div
                    className="tp-appoint select-field-arrow wow fadeInUp"
                    data-wow-delay=".7s"
                  >
                    <select title="Nom du service">
                      <option defaultValue="" disabled>
                        Nom du service
                      </option>
                      <option defaultValue="Service Commercial">
                        Service Commercial
                      </option>
                      <option defaultValue="Service Residentiel">
                        Service Residentiel
                      </option>
                      <option defaultValue="Service Industriel">
                        Service Industriel
                      </option>
                      <option defaultValue="Service d'entreprise">
                        Service d'entreprise
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-3 custom-pad-20">
              <div
                className="tp-appoint text-end wow fadeInUp"
                data-wow-delay=".9s"
              >
                <button type="submit" className="theme-btn text-white">
                  <i className="flaticon-enter"></i> Envoyez
                </button>
              </div>
            </div>
            {isLoading == 0 && (
              <div className="col-xl-12 col-lg-12 custom-pad-20">
                <div
                  className="tp-appoint wow fadeInUp alert alert-warning d-flex "
                  data-wow-delay=".1s"
                >
                  <div class="spinner-grow" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <h4>
                    Envoi en cours...
                  </h4>
                </div>
              </div>
            )}
            {isLoading == 1 && (
              <div className="col-xl-12 col-lg-12 custom-pad-20">
                <div
                  className="tp-appoint wow fadeInUp alert alert-success"
                  data-wow-delay=".1s"
                >
                  <h4>
                    Parfait! Votre demande a été envoyé. Nous vous contactons au
                    plus vite{" "}
                  </h4>
                </div>
              </div>
            )}
            {isLoading == -1 && (
              <div className="col-xl-12 col-lg-12 custom-pad-20">
                <div
                  className="tp-appoint wow fadeInUp alert alert-danger"
                  data-wow-delay=".1s"
                >
                  <h4>
                    Une erreur est survenu lors de lors de l'envoi. Merci de
                    réessayer
                  </h4>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default CtaArea;
